<h1>צור קשר</h1>

<p>ניתן ליצור איתנו קשר ב:</p>
<ul>
    <li>
        אימייל <a href="mailto:zapit.info@gmail.com">zapit.info@gmail.com</a>  
    </li>
    <li>
        טלפון/ווטסאפ <a href="tel:0585307276">058-5307276</a> 
    </li>
</ul>
